import { Link } from "react-router-dom";
import { Scissors, MapPin, Phone, Clock, Instagram, Facebook } from "lucide-react";
import { SOCIALS } from "@/lib/socials";

const TikTokIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64c.3 0 .59.05.87.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

export default function Footer() {
  return (
    <footer className="bg-[#050505] border-t border-white/10 pt-24 pb-10 px-6 lg:px-12" data-testid="footer">
      <div className="max-w-[1400px] mx-auto grid md:grid-cols-3 gap-16">
        <div>
          <div className="flex items-center gap-3 mb-6">
            <Scissors className="w-5 h-5 text-[#d4af37]" strokeWidth={1.5} />
            <span className="font-display text-xl text-white">
              The Barbers <span className="italic text-[#d4af37]">Chair</span>
            </span>
          </div>
          <p className="text-white/50 text-sm leading-relaxed max-w-xs font-body">
            Precision cuts, sharp lineups and a grooming experience built on excellence. Wilson & Clayton, North Carolina.
          </p>
          <div className="flex items-center gap-3 mt-6">
            <a href={SOCIALS.instagram.url} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-10 h-10 border border-white/15 flex items-center justify-center text-white/60 hover:border-[#d4af37] hover:text-[#d4af37] transition-colors" data-testid="footer-instagram">
              <Instagram className="w-4 h-4" strokeWidth={1.5} />
            </a>
            <a href={SOCIALS.tiktok.url} target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="w-10 h-10 border border-white/15 flex items-center justify-center text-white/60 hover:border-[#d4af37] hover:text-[#d4af37] transition-colors" data-testid="footer-tiktok">
              <TikTokIcon className="w-4 h-4" />
            </a>
            <a href={SOCIALS.facebook.url} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-10 h-10 border border-white/15 flex items-center justify-center text-white/60 hover:border-[#d4af37] hover:text-[#d4af37] transition-colors" data-testid="footer-facebook">
              <Facebook className="w-4 h-4" strokeWidth={1.5} />
            </a>
          </div>
        </div>

        <div className="space-y-5">
          <p className="overline text-xs text-[#d4af37]">Visit</p>
          <div className="flex items-start gap-3 text-white/60 text-sm">
            <MapPin className="w-4 h-4 mt-0.5 text-[#d4af37]" strokeWidth={1.5} />
            <div>
              <p className="overline text-[0.55rem] text-white/40 mb-0.5 tracking-widest">Wilson · Main</p>
              <span>4000 Ward Blvd, Unit E, Wilson, NC 27893</span>
              <p className="overline text-[0.55rem] text-white/40 mt-1 tracking-widest">Tue–Sun · 9:00 AM – 7:00 PM</p>
            </div>
          </div>
          <div className="flex items-start gap-3 text-white/60 text-sm">
            <MapPin className="w-4 h-4 mt-0.5 text-[#d4af37]" strokeWidth={1.5} />
            <div>
              <p className="overline text-[0.55rem] text-white/40 mb-0.5 tracking-widest">Clayton · Nights</p>
              <span>543 Averasboro Drive, Clayton, NC 27520</span>
              <p className="overline text-[0.55rem] text-white/40 mt-1 tracking-widest">Nightly · 9:00 PM – 11:00 PM</p>
            </div>
          </div>
          <div className="flex items-start gap-3 text-white/60 text-sm">
            <Phone className="w-4 h-4 mt-0.5 text-[#d4af37]" strokeWidth={1.5} />
            <span>(252) 315-3416</span>
          </div>
        </div>

        <div className="space-y-5">
          <p className="overline text-xs text-[#d4af37]">Ready?</p>
          <p className="font-display text-2xl text-white leading-snug">Your best cut is one tap away.</p>
          <Link
            to="/book"
            className="inline-flex items-center gap-2 border border-[#d4af37] px-8 py-3 overline text-xs text-[#d4af37] hover:bg-[#d4af37] hover:text-black transition-colors duration-300"
            data-testid="footer-book-btn"
          >
            Book an Appointment
          </Link>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-white/30 text-xs font-body">© {new Date().getFullYear()} The Barbers Chair. All rights reserved.</p>
        <div className="flex items-center gap-6">
          <Link to="/policies" className="text-white/40 text-xs font-body hover:text-[#d4af37] transition-colors" data-testid="footer-policies-link">Cancellation & No-Show Policy</Link>
          <p className="text-white/30 text-xs font-body">Cut by Reek · Book online 24/7</p>
        </div>
      </div>
    </footer>
  );
}
